import React, {Suspense,useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";
import clsx from 'clsx';

import AppBar from './AppBar';
import NavigationDrawer from './NavigationDrawer';
import SettingsDrawer from "./SettingsDrawer";
import TransitionAlert from '../alert/transitionAlert';
import Modal from './Modal';
import Tooltip from './Tooltip';
import AppLoading from "../loading/AppLoading";

import { appSetLeftDrawerOpen } from "../../redux/app/appActions";

import { styled, useTheme, LinearProgress, CssBaseline } from '@mui/material';

const PREFIX = 'AppLayout';

const classes = {
    root: `${PREFIX}-root`,
    content: `${PREFIX}-content`,
    area: `${PREFIX}-area`,
    contentShiftLeft: `${PREFIX}-contentShiftLeft`,
    contentShiftRight: `${PREFIX}-contentShiftRight`,
    contentShiftBoth: `${PREFIX}-contentShiftBoth`,
    toolbar: `${PREFIX}-toolbar`,
    linearProgress: `${PREFIX}-linearProgress`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
        height: '100%'
    },

    [`& .${classes.content}`]: {
        position: 'absolute',
        top: '0', bottom: '0', left: '0', right: '0',
        overflow: 'hidden',
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        marginRight: 0,
    },

    [`& .${classes.area}`]: {
        height: 'calc(100% - 64px)',
        overflow: 'hidden',
        minHeight: '0' //For Firefox
    },

    [`& .${classes.contentShiftLeft}`]: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: leftDrawerWidth,
    },

    [`& .${classes.contentShiftRight}`]: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: rightDrawerWidth,
    },

    [`& .${classes.contentShiftBoth}`]: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: leftDrawerWidth,
        marginRight: rightDrawerWidth,
    },

    [`& .${classes.toolbar}`]: { ...theme.mixins.toolbar, height: "64px" },

    [`& .${classes.linearProgress}`]: {
        height: '1px'
    }
}));

const leftDrawerWidth = 240;
const rightDrawerWidth = 360;

export default function AppLayout({ children }) {

    // const theme = useTheme();
    const dispatch = useDispatch();

    // console.log('-----------AppLayout:render()-----------', theme);

    // App State
    const app = useSelector(state => state.app);
    const auth = useSelector(state => state.auth);
	const configData = useSelector(state => state.config.data);
    const user = useSelector(state => state.user);
	const isThemeLight = useSelector(state => state.persist.themeLight);

	useEffect(() => {
		// window.document.body.style.backgroundColor = (isThemeLight ? configData.lightTheme.palette.primary.background : configData.darkTheme.palette.primary.background);
	},[isThemeLight]);

    // console.log('children', children);
    function hideDrawer(event) {
        if (app.leftDrawerOpen) {

            dispatch(appSetLeftDrawerOpen(false));

            event.stopPropagation();
            return false;
        }
    }

    return (
        <Root className={classes.root} onClick={hideDrawer}>
            {app.leftDrawerOpen &&
            // Mask Over Content & Settings
            <div id={"fullmask"} style={{
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                backgroundColor: 'rgba(0,0,0,0.3)',
                position: 'absolute',
                zIndex: 999
            }}>
            </div>
            }
            <CssBaseline />
			<Suspense fallback={<React.Fragment/>}>
				<AppBar />
			</Suspense>
            {auth.authenticated && user.authorized &&
                <NavigationDrawer/>
            }
            <main className={clsx(classes.content, {
                // [classes.contentShiftLeft]: app.leftDrawerOpen && !app.rightDrawerOpen && auth.authenticated && user.authorized,
                // [classes.contentShiftBoth]: app.leftDrawerOpen && app.rightDrawerOpen && auth.authenticated && user.authorized,
                [classes.contentShiftRight]: app.rightDrawerOpen && auth.authenticated && user.authorized,
                })}>
                <div className={classes.toolbar} />
                <div className={classes.area}>
                    {!children &&
                        <React.Fragment>
                            <LinearProgress className={classes.linearProgress}/>
                            <div style={{height: '100%', width: '100%', overflow: 'hidden'}}>
                                <AppLoading message={"We're powered by data and technology enabled. Please wait while the circuts connect..."}/>
                            </div>
                        </React.Fragment>
                    }
                    {children &&
                        <React.Fragment>
                            <TransitionAlert/>
                            <div style={{height: '100%', width: '100%', overflow: 'auto'}}>
                                {children}
                            </div>
                        </React.Fragment>
                    }
                </div>
            </main>
            {app.modalContent &&
                <Modal/>
            }
            {app.tooltipContent &&
                <Tooltip/>
            }
            {auth.authenticated && user.authorized &&
                <SettingsDrawer/>
            }
        </Root>
    );
}
